import { useEffect, useState } from 'react';

export type AppNavProgress = { label: string; value: number } | null;

let current: AppNavProgress = null;
const listeners = new Set<(p: AppNavProgress) => void>();

export function setAppNavProgress(p: AppNavProgress) {
  current = p;
  listeners.forEach((fn) => fn(p));
}

export function useAppNavProgress(): AppNavProgress {
  const [p, setP] = useState<AppNavProgress>(current);
  useEffect(() => {
    listeners.add(setP);
    return () => {
      listeners.delete(setP);
    };
  }, []);
  return p;
}
